import { __ } from '@wordpress/i18n';

export const sourceTypes = [
	{ label: __('Upload', 'model-viewer'), value: 'upload' },
	{ label: __('Link', 'model-viewer'), value: 'link' }
];

export const loadingTypes = [
	{ label: __('Auto', 'model-viewer'), value: 'auto' },
	{ label: __('Lazy', 'model-viewer'), value: 'lazy' },
	{ label: __('Eager', 'model-viewer'), value: 'eager' }
];